module.exports = __webpack_public_path__ + "img/Bjd3.cd506278.jpg";